import React from "react"

/* Filas del resumen de compra (ModalFormasPago / ModalDetalle) que explican el descuento con claridad:
   precio normal vs. precio con descuento, y SOBRE QUE se aplico (precio base o precio final).
   Los numeros salen de GetValores() (utils/CarritoLocalStorang.js): descuento_porcentaje, descuento_aplica_sobre,
   subtotal_sin_descuento, descuento_monto_base, total_sin_descuento, descuento_monto y total_con_descuento.
   Sin descuento activo las filas son las de siempre. */

export const dinero = (n) => `$${(parseFloat(n) || 0).toFixed(2)}`
const pctTxt = (n) => `${Number(n) % 1 === 0 ? Number(n) : Number(n).toFixed(2)}%`

const esMontoFijo = (precios) => precios?.descuento_tipo === "monto"
export const hayDescuento = (precios) =>
  Number(precios?.descuento_porcentaje) > 0 || (esMontoFijo(precios) && Number(precios?.descuento_monto) > 0)

// "Descuento 10% (sobre el precio final)" o, por monto fijo, "Descuento $10.00 por entrada (3 entradas)"
const etiquetaDescuento = (precios) => {
  if (!esMontoFijo(precios)) return `Descuento ${pctTxt(precios.descuento_porcentaje)} (sobre el precio final):`
  const porCompra = precios.descuento_monto_por === "compra"
  const entradas = Number(precios.descuento_entradas) || 0
  return `Descuento ${dinero(precios.descuento_valor_unitario)} ${porCompra ? "por compra" : `por entrada (${entradas} ${entradas === 1 ? "entrada" : "entradas"})`}:`
}
const sobreBase = (precios) => precios?.descuento_aplica_sobre === "base"

const Fila = ({ etiqueta, valor, className = "", fuerte = false }) => (
  <tr className={className}>
    <th scope="row"></th>
    <td className="text-end">{fuerte ? <strong>{etiqueta}</strong> : etiqueta}</td>
    <td className="text-center">{fuerte ? <strong>{valor}</strong> : valor}</td>
  </tr>
)

/* Reemplaza la fila "Subtotal". Con descuento sobre el PRECIO BASE el subtotal ya viene rebajado, asi que se
   muestra el precio normal (tachado), cuanto se descuenta y el subtotal resultante. */
export function FilasSubtotal({ precios }) {
  if (hayDescuento(precios) && sobreBase(precios)) {
    return (
      <>
        <Fila etiqueta="Precio normal de los boletos:" valor={<s className="text-muted">{dinero(precios.subtotal_sin_descuento)}</s>} />
        <Fila
          etiqueta={<span className="text-success">Descuento {pctTxt(precios.descuento_porcentaje)} (sobre el precio base):</span>}
          valor={<span className="text-success">-{dinero(precios.descuento_monto_base)}</span>}
        />
        <Fila etiqueta="Subtotal con descuento:" valor={dinero(precios.subtotal)} />
      </>
    )
  }
  return <Fila etiqueta="Subtotal:" valor={dinero(precios?.subtotal)} />
}

/* Reemplaza la fila(s) de descuento + total. `etiquetaTotal` es el texto del total cuando NO hay descuento. */
export function FilasTotal({ precios, etiquetaTotal = "Total" }) {
  const totalPagar = precios?.total_con_descuento ?? precios?.total
  if (!hayDescuento(precios)) {
    return <Fila etiqueta={etiquetaTotal} valor={dinero(totalPagar)} />
  }
  const ahorro = Number(precios.descuento_monto) || 0
  return (
    <>
      <Fila etiqueta="Total sin descuento:" valor={<s className="text-muted">{dinero(precios.total_sin_descuento)}</s>} />
      {!sobreBase(precios) && (
        <Fila
          etiqueta={<span className="text-success">{etiquetaDescuento(precios)}</span>}
          valor={<span className="text-success">-{dinero(ahorro)}</span>}
        />
      )}
      <Fila etiqueta="Total con descuento:" valor={dinero(totalPagar)} fuerte />
      {ahorro > 0 && (
        <tr>
          <td colSpan={3} className="text-center">
            <small className="text-success">🎉 Con tu descuento ahorras {dinero(ahorro)}</small>
          </td>
        </tr>
      )}
    </>
  )
}
